module.exports = __webpack_public_path__ + "f95c68bcd04eebc7f53afc2d6cd3e0bb.woff2";